var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { styled } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';
import { Flex } from '@creditas-ui/layout';
import { InputLabel } from './InputLabel';
import { InputHint } from './InputHint';
var RadioElements = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  flex-direction: column;\n  word-break: break-word;\n  font-family: ", ";\n  margin: ", ";\n  overflow: hidden;\n"])), selectTheme('radio.base.fontFamily'), selectTheme('radio.container.margin'));
var InputLabelStyled = styled(InputLabel)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 5px 0 0 0;\n"])));
var InputHintStyled = styled(InputHint)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: ", ";\n"])), selectTheme('radio.hint.margin'));
export { RadioElements, InputLabelStyled as InputLabel, InputHintStyled as InputHint };